import ArticleView from '@/modules/articles/components/articles/article-view';
import { Article } from '@/modules/articles/model/article';
import { useWidgetLoaderData, useWidgetNavigate } from '@/core/widgets/export';

export default function ArticleViewPage({
  showBookmark = true,
  showBack = true,
  showPin = true,
}: {
  showBookmark?: boolean;
  showBack?: boolean;
  showPin?: boolean;
}) {
  const navigate = useWidgetNavigate();
  const article = useWidgetLoaderData();

  return (
    <>
      <ArticleView
        article={article as Article}
        onClose={() => navigate(-1)}
        showPin={showPin}
        showBack={showBack}
        showBookmark={showBookmark}
      />
    </>
  );
}
